export function errorHandler(action) {
    switch (action) {
        case '403':
            return 'Access Denied';
        case '412':
            return 'Cannot create duplicate records';
        case '429':
            return 'Cannot process request. Please try Later';
        case '503':
            return 'Server not available';
        case '422':
            return 'Something went wrong, try again later';
        case '999': // This is for handling unknown problems/exceptions
            return 'Something went wrong, try again later';
    }
}
